import { useCallback, useEffect, useRef } from 'react';
import { httpApi } from '@api/http.api.ts';

interface FrontError {
    errorMessage: string;
    url: string;
    timestamp: string;
    stacktrace?: string;
    source?: string;
}

export const useFrontErrorLogger = () => {
    const lastErrorRef = useRef<FrontError | null>(null);

    // send to your logging endpoint
    const logError = useCallback((errorDetails: FrontError) => {
        httpApi.post(`logs/front-error`, errorDetails).catch((err) => {
            console.error('Error logging failed:', err);
        });
    }, []);

    useEffect(() => {
        window.onerror = function (
            message: string | Event,
            source?: string,
            _lineno?: number,
            _colno?: number,
            error?: Error,
        ) {
            const currentError: FrontError = {
                errorMessage: String(message),
                url: window.location.href,
                timestamp: new Date().toISOString(),
                stacktrace: error ? error.stack : '',
                source,
            };

            // only log if it’s different from last time
            if (JSON.stringify(currentError) !== JSON.stringify(lastErrorRef.current)) {
                logError(currentError);
                lastErrorRef.current = currentError;
            }
        };
        // cleanup on unmount
        return () => {
            window.onerror = null;
        };
    }, [logError]);
};
